var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.88501 5.16686L5.57568 6.85753L4.63301 7.80019L1.33301 4.5002L4.63301 1.2002L5.57568 2.14286L3.88501 3.83353H8.66634C10.0808 3.83353 11.4374 4.39543 12.4376 5.39563C13.4378 6.39582 13.9997 7.75237 13.9997 9.16686C13.9997 10.5813 13.4378 11.9379 12.4376 12.9381C11.4374 13.9383 10.0808 14.5002 8.66634 14.5002H2.66634V13.1669H8.66634C9.72721 13.1669 10.7446 12.7454 11.4948 11.9953C12.2449 11.2451 12.6663 10.2277 12.6663 9.16686C12.6663 8.106 12.2449 7.08858 11.4948 6.33843C10.7446 5.58829 9.72721 5.16686 8.66634 5.16686H3.88501Z",
    fill: "#5B73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open-icon.7179095e887a877a98d11f6207ad1bc5.svg";
export { ForwardRef as ReactComponent };